<template>
    <div id="filters">
        <FilterBox
          v-for="filterGroup in filters"
          :key="filterGroup.groupName"
          :filterGroup="filterGroup"
          :selectedFilters="selectedFilters"
          @toggle-filter="(option)=>$emit('toggle-filter', option)"
        />
    </div>
</template>

<style scoped>
#filters {
    position: absolute;
    max-height: 100%;
    width: 320px;
    z-index: 10000;
    right: 0;
    bottom: 0;
    background-color: white;
    border-right: 2px solid black;
    box-sizing: border-box;
    overflow-y: scroll;
}
@media screen and (max-width: 1000px) {
  #filters {
    width: 100%;
  }
}
#filters{
  -ms-overflow-style: none;  /* Internet Explorer 10+ */
  scrollbar-width: none;  /* Firefox */
}
#filters::-webkit-scrollbar {
  display: none;  /* Safari and Chrome */
}
</style>

<script>
import FilterBox from './FilterBox.vue';
import filters from '../data/filters';

export default {
  name: 'Filters',
  components: {
    FilterBox,
  },
  props: ['selectedFilters'],
  data() {
    return {
      filters,
    };
  },
};
</script>
